import { render, staticRenderFns } from "./case-distribution.vue?vue&type=template&id=3f56c826&scoped=true"
import script from "./case-distribution.vue?vue&type=script&lang=ts"
export * from "./case-distribution.vue?vue&type=script&lang=ts"
import style0 from "./case-distribution.vue?vue&type=style&index=0&id=3f56c826&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56c826",
  null
  
)

export default component.exports